import React from 'react'

function StraightFace ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 336 336'>
      <circle class='cls-1' cx='232' cy='136' r='8' />
      <circle class='cls-1' cx='104' cy='136' r='8' />
      <path class='cls-1' d='M168,0A168,168,0,1,0,336,168,168,168,0,0,0,168,0ZM104,112a24,24,0,1,1-24,24A24,24,0,0,1,104,112ZM248,224H88a8,8,0,0,1,0-16H248a8,8,0,0,1,0,16Zm-16-64a24,24,0,1,1,24-24A24,24,0,0,1,232,160Z' />
    </svg>
  )
}

StraightFace.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default StraightFace
